import { inject, provide, ref } from 'vue';
import { loadStripe, Stripe } from '@stripe/stripe-js';
import config from '../config';

interface UseStripeService {
  getStripe: () => Promise<Stripe | null>;
}

const stripeInstance = ref<Stripe | null>(null);

const getStripe = async (): Promise<Stripe | null> => {
  if (!stripeInstance.value) {
    const stripeApiKey = config.get()?.useStripeSandbox
      ? config.get()?.stripeApiKeyProdSandbox : config.get()?.stripeApiKey;
    stripeInstance.value = await loadStripe(stripeApiKey);
  }

  return stripeInstance.value;
};

export const useStripeService = () => {
  provide('getStripe', getStripe);
};

export const useStripe = (): UseStripeService => ({
  getStripe: inject('getStripe') as () => Promise<Stripe | null>,
});
